import { Filter } from 'lucide-react';
import type {
  VettingStatusFilter,
  StateCategoryBreakdown,
} from '../../../types/analytics.types';
import { VETTING_STATUS_OPTIONS } from '../../../types/analytics.types';

type CategoryOption = Pick<StateCategoryBreakdown, 'categoryId' | 'categoryName'>;

type CoverageFiltersProps = {
  categories: CategoryOption[];
  selectedCategoryId: string | null;
  onCategoryChange: (id: string | null) => void;
  selectedVettingStatus: VettingStatusFilter;
  onVettingStatusChange: (status: VettingStatusFilter) => void;
};

const VETTING_LABELS: Record<VettingStatusFilter, string> = {
  APPROVED: 'Approved',
  PENDING: 'Pending',
  ALL: 'All Statuses',
};

export const CoverageFilters = ({
  categories,
  selectedCategoryId,
  onCategoryChange,
  selectedVettingStatus,
  onVettingStatusChange,
}: CoverageFiltersProps) => {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <Filter className="w-4 h-4 text-gray-400" />

      <select
        value={selectedCategoryId ?? ''}
        onChange={(e) => onCategoryChange(e.target.value || null)}
        className="px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white"
        aria-label="Filter by category"
      >
        <option value="">All Categories</option>
        {categories.map((c) => (
          <option key={c.categoryId} value={c.categoryId}>
            {c.categoryName}
          </option>
        ))}
      </select>

      <select
        value={selectedVettingStatus}
        onChange={(e) =>
          onVettingStatusChange(e.target.value as VettingStatusFilter)
        }
        className="px-3 py-1.5 text-sm border border-gray-300 rounded-md bg-white"
        aria-label="Filter by vetting status"
      >
        {VETTING_STATUS_OPTIONS.map((status) => (
          <option key={status} value={status}>
            {VETTING_LABELS[status]}
          </option>
        ))}
      </select>
    </div>
  );
};
